import React, { Component } from 'react';
import { common, FilterCollection, Collection } from 'plato-js-client';
import { Alert, Spinner, Button, Table, Modal, ModalHeader, ModalBody, Col, Form, FormGroup, Label, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import PropertyRooms from './PropertyRooms';
import moment from 'moment'

class JobDetail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      wo: {},
      bookingnotes: {},
      property: {},
      propertyRooms: null,
      bookingRooms: null,
      errorStr: '',
      error: {},
      showBookingDetails: false,
      showAddress: false,
      disableSubmitCostButton: false,
      otherBookings: 0,
      loadingReport: false,
    };
    this.onDismiss = this.onDismiss.bind(this);
  }

  componentDidMount = () => {
    this.getJobDetails();
  }

  onDismiss() {
    this.setState({ errorStr: '', successStr: '' });
  }

  getPropertyDetails = (workorder) => {
    // If we have a booking attached we don't need to fetch property details
    if (workorder.booking.id
      && workorder.booking.property
      && workorder.booking.property.id
    ) {
      this.setState({ property: workorder.booking.property });
      return workorder.booking.property;
    } else {
      var property = new common.Property(workorder.property.id);
      return property.get()
        .then((propertyData) => {
          this.setState({ property });
          return propertyData;
        }).catch((error) => {
          this.setState({
            property: null,
            error: error,
            errorStr: `Unable to load property - ${error.entity ? error.entity.errorDescription : error.message}`
          })
        });
    }
  }

  getPreviousCustomerBookings = workorder => {
    if (workorder.booking.guesttype === 'Customer'
        && workorder.booking.customers
        && workorder.booking.customers.collection.length > 0
        && workorder.booking.property
        && workorder.booking.property.id) {

      var bookings = new FilterCollection({
        path: 'booking',
        object: common.Booking,
      });
      bookings.fields = 'id';

      bookings.addFilters([{
        id: "!" + workorder.booking.id,
        customer_id: workorder.booking.customers.collection[0].details.id,
        propertyid: workorder.booking.property.id,
        confirmedbooking: 1,
        cancelledbooking: 0,
        transferredbooking: 0
      }]);

      bookings.fetch().then(() => {
        this.setState({ otherBookings: bookings.total });
      });
    }
  }

  getRooms = (job) => {
    let bookingRooms = new Collection({
      path: 'room',
      object: common.BookingRoom,
      parent: job.booking
    });

    let propertyRooms = new Collection({
      path: 'room',
      object: common.PropertyRoom,
      parent: this.state.property
    });

    var proms = [propertyRooms.fetch()];

    if (job.booking && job.booking.id) {
      proms.push(bookingRooms.fetch());
    }

    return Promise.all(proms).then(() => {
      this.setState({ bookingRooms: bookingRooms, propertyRooms: propertyRooms });
    }, (error) => {
      this.setState({ error: error, loading: false, propertyRooms: null });
    });
  }

  getJobDetails = () => {
    // Request workorder ( which contains booking info )

    let job = new common.WorkOrder(this.props.match.params.workorderid);
    return job.get()
      .then(() => this.getPropertyDetails(job))
      .then(() => this.getRooms(job))
      .then(() => this.getPreviousCustomerBookings(job))
      .then(() => {
        // MS Handle case where booking not present (shouldn't be a problem for the template stuff) - get the property details.
        if (job.booking && job.booking.id) {
          // If there is a booking then get any booking notes
          let bookingnotes = new FilterCollection({
            path: 'note',
            object: common.Note,
            parent: job.booking
          });
          bookingnotes.addFilters([{
            archivedby: null
          }]);
          bookingnotes.fetch().then(
            // use a filtered set of bookingnotes
            () => this.setState({
              wo: job,
              bookingnotes: bookingnotes.filter(bn => bn.note.visibletocleaner || bn.note.visibletokeyholder || bn.note.visibletoowner),
              showBookingDetails: job.status === 'Approved',
              error: {},
              errorStr: ''
            }),
            (error) => this.setState({
              error: error,
              errorStr: `Unable to fetch booking notes - ${error.entity ? error.entity.errorDescription : error.message}`
            })
          );

          if (job.status === 'Invoice Rejected') {
            let wonotes = new FilterCollection({
              path: 'note',
              object: common.Note,
              parent: job
            });
            wonotes.addFilters([{
              archivedby: null
            }]);
            wonotes.fetch().then(
              () => this.setState({
                wonotes: wonotes.filter(wn => wn.note.visibletocleaner || wn.note.visibletokeyholder || wn.note.visibletoowner),
                error: {},
                errorStr: ''
              }),
              (error) => this.setState({
                error: error,
                errorStr: `Unable to fetch Job notes - ${error.entity ? error.entity.errorDescription : error.message}`
              })
            );
          }
        } else {
          this.setState({
            wo: job,
            bookingnotes: {},
            showBookingDetails: false,
            error: {},
            errorStr: ''
          });
        }
    },
    (error) => this.setState({
      error: error,
      errorStr: `Unable to fetch job details - ${error.entity ? error.entity.errorDescription : error.message}`
    }));
  }

  toggleBooking = () => {
    this.setState({ showBookingDetails: !this.state.showBookingDetails });
  }

  markAsComplete = () => {
    let fields = { completeddate: moment().format('YYYY-MM-DD') };
    this.state.wo.update(fields).then(
      () => this.getJobDetails(),
      (error) => this.setState({
        error: error,
        errorStr: `Unable to mark job as completed - ${error.entity ? error.entity.errorDescription : error.message}`
      })
    );
  }

  submitCosts = () => {
    this.setState({ disableSubmitCostButton: true }, () => {
      let woi = new common.WorkOrderInvoice(this.state.wo.id);
      woi.supplierinvoice_invoicedate = moment().format('YYYY-MM-DD');
      woi.create().then(
        () => this.setState({
          error: {},
          errorStr: '',
          successStr: 'Job costs have been successfully submitted',
        }, () => this.getJobDetails()),
        (error) => this.setState({
          error: error,
          errorStr: `Unable to submit costs - ${error.entity ? error.entity.errorDescription : error.message}`
        })
      );
    });
  }

  doReport = async () => {
    const { property } = this.state;

    const report = this.props.reports.findOne(
      report => report.filename === 'PropertyQuestionAnswer.rptdesign'
    );

    if (!report) {
      this.setState({
        errorStr: 'Unable to locate the property information report.',
      });
      return;
    }

    const params = {
      PropertyId: property.id,
      Tag: 'Cleaning',
      _format: 'pdf'
    };

    this.setState({ loadingReport: true });

    report.run(params).then(
      reportRun => {
        if (reportRun.result && reportRun.status === 'complete') {
          reportRun.result.file.get().then(() => {
            var link = document.createElement('a');
            link.download = reportRun.result.filename;
            link.href = reportRun.result.file.url;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            this.setState({
              loadingReport: false,
              successStr: "Report generated"
            });
          });
        }
      },
      error => {
        this.setState({
          error,
          errorStr: 'Unable to run the property information report.',
          loadingReport: false
        });
      }
    );
  };

  render() {
    if (this.state.wo.id && this.state.wo.id === parseInt(this.props.match.params.workorderid, 10)) {
      let wo = this.state.wo;
      let property = this.state.property;
      let bookingName = '';
      let bookingExtras = [];
      let bookingNotes = [];
      let woNotes = [];
      let woExpenses = [];
      let displayStatus = '';
      if (wo.booking.id) {
        // Work out booking name
        switch (wo.booking.guesttype) {
          case 'Owner':
            bookingName = `Owner Booking - ${wo.booking.ownerbookingtype.description}`;
            break;
          case 'None':
            bookingName = `Agency Booking - ${wo.booking.agencybookingtype.description}`;
            break;
          default:
            bookingName = wo.booking.customers.collection[0].name;
            break;
        }

        // list out any applicable extras
        bookingExtras = wo.booking.extras
          .filter(extra => extra.configuration.visibletoowner)
          .map(extra => extra.extra.extracode);

        // get booking notes
        bookingNotes = this.state.bookingnotes.map(bn => <NoteRow key={bn.note.id} note={bn.note} />)
      }

      // get workorder notes
      if (this.state.wonotes && this.state.wonotes.length > 0) {
        woNotes = this.state.wonotes.map(bn => <RejectionNoteRow key={bn.note.id} note={bn.note} />)
      }

      //check for periods in a booking
      let bookingPeriods = 1;
      if (wo.booking && wo.booking.periods && wo.booking.periods > 1) {
        bookingPeriods = wo.booking.periods;
      }

      // get booking expenses
      woExpenses = wo.expenses.map(expense => <ExpenseRow
        key={expense.id}
        expense={expense}
        status={wo.status}
        updateJob={this.getJobDetails}
        user={this.props.user}
        bookingPeriods={bookingPeriods}
        woPerPeriod={wo.perperiod}
      />)

      switch (wo.status) {
        case 'Approved':
          displayStatus = `To do`;
          break;
        case 'Completed':
          displayStatus = `${wo.status} - Submit costs`;
          break;
        case 'Invoiced':
          displayStatus = `Costs submitted - awaiting approval`;
          break;
        case 'Invoice Rejected':
          displayStatus = `Costs rejected`;
          break;
        case 'Invoice Approved':
          displayStatus = `Costs approved`;
          break;
        default:
          break;
      }

      return (
        <React.Fragment>
          {this.state.errorStr &&
            <Alert color="danger" isOpen toggle={this.onDismiss} className="my-2">
              {this.state.errorStr}
            </Alert>
          }
          {this.state.successStr &&
            <Alert color="success" isOpen toggle={this.onDismiss} className="my-2">
              {this.state.successStr}
            </Alert>
          }
          <Table>
            <tbody>
              <tr>
                <td>Job ID</td>
                <td>{wo.id}</td>
              </tr>
              <tr>
                <td>Job status</td>
                <td>{displayStatus}</td>
              </tr>
              <tr>
                <td>Required Date</td>
                <td>{moment(wo.preferredstartdatetime).format('DD/MM/YYYY')}</td>
              </tr>
              <tr>
                <td>Property</td>
                <td>
                  {property &&
                    <React.Fragment>
                      {property.tabspropref} - {property.name}{' '}
                      <Button
                        title='Export to PDF'
                        onClick={this.doReport}
                        size='sm'
                        disabled={this.state.loadingReport}
                      >
                        Export Information to PDF
                      </Button>
                      {this.state.loadingReport && (
                        <Spinner
                          size="sm"
                          color="primary"
                          className="ml-2"
                        />
                      )}
                    </React.Fragment>
                  }
                </td>
              </tr>
              <tr>
                <td>Job Title</td>
                <td>{wo.shortdescription}</td>
              </tr>
              {wo.fulldescription ?
                <tr>
                  <td>Detailed Description</td>
                  <td>{wo.fulldescription}</td>
                </tr>
                : null
              }
              {wo.status === 'Invoice Rejected' && woNotes.length > 0 &&
                <React.Fragment>
                  <tr>
                    <td colSpan="2"><strong>Rejection notes</strong></td>
                  </tr>
                  {woNotes}
                </React.Fragment>
              }
              {woExpenses.length > 0 &&
                <React.Fragment>
                  <tr>
                    <td colSpan="2"><strong>Job items</strong></td>
                  </tr>
                  {woExpenses}
                </React.Fragment>
              }
              {wo.booking.id &&
                <React.Fragment>
                  <tr>
                    <td colSpan="2" onClick={this.toggleBooking}>
                      <strong>Booking</strong> {!this.state.showBookingDetails ? '(click to view)' : '(click to hide)'}
                    </td>
                  </tr>
                  {this.state.showBookingDetails &&
                    <React.Fragment>
                      <tr>
                        <td>Booking ID</td>
                        <td>{wo.booking.id}</td>
                      </tr>
                      <tr>
                        <td>Booking Dates</td>
                        <td>{moment(wo.booking.fromdate).format('DD/MM/YYYY')} - {moment(wo.booking.todate).format('DD/MM/YYYY')}</td>
                      </tr>
                      <tr>
                        <td>Booking Name</td>
                        <td>
                          {bookingName}
                          {wo.booking.guesttype === 'Customer' &&
                          <React.Fragment>
                            {' - '}{this.state.otherBookings} other bookings at property
                          </React.Fragment>
                          }
                        </td>
                      </tr>
                      <tr>
                        <td>Ad/Ch/Inf/Pet</td>
                        <td>{wo.booking.adults}/{wo.booking.children}/{wo.booking.infants}/{wo.booking.pets}</td>
                      </tr>
                      <tr>
                        <td>Extras</td>
                        <td>{bookingExtras.join(',')}</td>
                      </tr>
                      <PropertyRooms bookingRooms={ this.state.bookingRooms } propertyRooms={ this.state.propertyRooms } />
                      {bookingNotes.length > 0 &&
                        <React.Fragment>
                          <tr>
                            <td colSpan="2"><strong>Booking Notes</strong></td>
                          </tr>
                          {bookingNotes}
                        </React.Fragment>
                      }
                    </React.Fragment>
                  }
                </React.Fragment>
              }

              <tr>
                <td></td>
                <td>
                  {wo.status === 'Approved' && moment().isAfter(moment(wo.preferredstartdatetime).subtract(2, 'days')) &&
                    <React.Fragment>
                      <Alert color="info">
                        If you are unable to start or complete the job shown here please contact the local team otherwise click the button below when the job has been completed.
                      </Alert>
                      <Button
                        color='primary'
                        disabled={this.state.updating}
                        onClick={this.markAsComplete}>
                        Mark job as completed
                      </Button>
                    </React.Fragment>
                  }
                  {(wo.status === 'Completed' || wo.status === 'Invoice Rejected') && !this.props.user.doesnotinvoiceus &&
                    <Button color='primary' disabled={this.state.updating || this.state.disableSubmitCostButton} onClick={this.submitCosts}>Submit Costs</Button>
                  }
                </td>
              </tr>
            </tbody>
          </Table>
        </React.Fragment>
      );
    }
    return (<div style={{ width: "100%", display: 'flex', justifyContent: "center" }}>
      <Spinner style={{ width: '3rem', height: '3rem', margin: "20px auto" }} color='secondary' />
    </div>);
  }

}

class NoteRow extends Component {

  render() {
    let notetexts = this.props.note.notetexts.map(notetext => (
      <span key={notetext.id}>{notetext.notetext}</span>
    ));

    return (
      <React.Fragment>
        <tr>
          <td>{this.props.note.subject}</td>
          <td>{notetexts}</td>
        </tr>

      </React.Fragment>
    );
  }
}

class RejectionNoteRow extends Component {

  render() {
    let notetexts = this.props.note.notetexts.map((notetext, i) => (
      <React.Fragment key={notetext.id}>
        {i > 0 && <hr />}
        <p>{notetext.notetext}</p>
      </React.Fragment>
    ));

    return (
      <React.Fragment>
        <tr>
          <td colSpan='2'>
            <Alert color="danger">
              <h6 className="alert-heading">{this.props.note.subject}</h6>
              {notetexts}
            </Alert>
          </td>
        </tr>
      </React.Fragment>
    );
  }
}

class ExpenseRow extends Component {

  constructor(props) {
    super(props);

    const vr = JSON.parse(localStorage.getItem('vatrates'));
    let vatrate = 0;
    if (this.props.user.vatnumber) {
      vatrate = vr.vatrates.collection.filter(rate => rate.vatband.id === this.props.expense.costitemcode.vatband.id && moment().isBetween(rate.fromdate, rate.todate, 'day', '[]'));
    }

    this.state = {
      showEstimateModal: false,
      saving: false,
      vatrate: vatrate && vatrate.length > 0 && vatrate[0].percentage ? vatrate[0].percentage : 0
    };
    if (this.state.vatrate !== 0) {
      if (this.props.expense.amountvat && this.props.expense.amountvat !== 0) {
        this.state.amountvat = this.props.expense.amountvat;
      } else {
        let net = (this.props.expense.amountnet !== null) ? this.props.expense.amountnet : this.props.expense.amountnetestimate;
        this.state.amountvat = parseFloat(net * (this.state.vatrate / 100)).toFixed(2);
      }
    }
    this.state.amountnet = parseFloat((this.props.expense.amountnet !== null) ? this.props.expense.amountnet : this.props.expense.amountnetestimate).toFixed(2);
    this.state.amountperiods = this.props.expense.chargingperiodsactual ? this.props.expense.chargingperiodsactual : this.props.expense.chargingperiodsestimate;

    this.onDismiss = this.onDismiss.bind(this);
  }

  onDismiss() {
    this.setState({ errorStr: '' });
  }

  toggleModal = () => {
    this.setState({ showEstimateModal: !this.state.showEstimateModal, saving: false });
  }

  handleNetChange = (e) => {
    e.preventDefault();
    // Recalc VAT
    this.setState({
      amountnet: e.target.value,
      amountvat: e.target.value * (this.state.vatrate / 100)
    });
  }

  handlePeriodChange = (e) => {
    e.preventDefault();
    let per = this.props.expense.amountnetestimate / parseFloat(this.props.expense.chargingperiodsestimate);
    let amountnet = e.target.value * per;
    this.setState({
      amountperiods: e.target.value,
      amountnet: amountnet,
      amountvat: amountnet * (this.state.vatrate / 100)
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({ saving: true });

    // MS - Validation
    let fields = {
      amountnet: this.amountnet.value,
      amountvat: this.state.vatrate === 0 ? 0 : this.state.amountvat,
      notes: this.notes.value
    };
    if (this.props.expense.chargingperiod.id) {
      fields.chargingperiodsactual = this.state.amountperiods;
    }
    this.props.expense.update(fields).then(
      () => this.setState({
        error: {},
        errorStr: '',
        saving: false,
        showEstimateModal: !this.state.showEstimateModal
      }, () => this.props.updateJob()),
      (error) => this.setState({
        error: error,
        errorStr: `Unable to update costs - ${error.message}`,
        saving: false
      })
    );

  }

  perPeriodAndPeriods() {
    if (this.props.woPerPeriod && this.props.bookingPeriods && this.props.bookingPeriods > 1) {
      return true;
    }
    return false;
  }

  amountWithPerPeriods(amount) {
    if (this.perPeriodAndPeriods()) {
      return "£ " + amount + " (£ " + parseFloat(amount / this.props.bookingPeriods).toFixed(2) + " per period)";
    }
    return "£ " + amount;
  }

  render() {
    let note = [];
    if (this.props.expense.notes) {
      note.push(<p>{this.props.expense.notes}</p>);
    }

    let chargingPeriodDescription = '';
    if (this.props.expense.chargingperiod.id) {
      let chargingPeriodEstimate = parseFloat(this.props.expense.chargingperiodsestimate);
      let per = this.props.expense.amountnetestimate / chargingPeriodEstimate;
      let chargingPeriodName = this.props.expense.chargingperiod.chargingperiod.toLowerCase();

      chargingPeriodDescription = [
        chargingPeriodEstimate,
        chargingPeriodName + 's',
        ' @ ',
        '£' + per.toFixed(2),
        ' per ',
        chargingPeriodName
      ].join(' ');
    }

    return (
      <tr>
        <td>{this.props.expense.description}</td>
        <td>
          {this.props.expense.amountnet !== null ?
            this.amountWithPerPeriods(parseFloat(this.props.expense.amountnet).toFixed(2))
            : this.amountWithPerPeriods(this.props.expense.amountnetestimate.toFixed(2))
          }
          {this.state.vatrate !== 0 &&
            ' (plus £' + parseFloat(this.state.amountvat).toFixed(2) + ' VAT)'
          }
          {(this.props.status === 'Completed' || this.props.status === 'Invoice Rejected') &&
            <Button className="btn float-right" outline color="primary" size="sm" onClick={this.toggleModal} >Edit</Button>
          }
          {this.props.expense.notes &&
            <p>{this.props.expense.notes}</p>
          }
          <Modal
            isOpen={this.state.showEstimateModal}
            toggle={this.toggleModal}
          >
            <ModalHeader toggle={this.toggleModal}>Edit Cost</ModalHeader>
            <ModalBody>
              {this.state.errorStr &&
                <Alert color="danger" isOpen toggle={this.onDismiss}>
                  {this.state.errorStr}
                </Alert>
              }
              <Form onSubmit={this.handleSubmit}>
                <FormGroup row>
                  <Label sm={2} for="estcost">Estimated Cost</Label>
                  <Col sm={4}>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">£</InputGroupAddon>
                      <Input disabled type="number" value={parseFloat(this.props.expense.amountnetestimate).toFixed(2)} />
                    </InputGroup>
                  </Col>
                  {this.props.expense.chargingperiod.id &&
                    <Col sm={6}>
                      {chargingPeriodDescription}
                    </Col>
                  }
                </FormGroup>

                {this.props.expense.chargingperiod.id &&
                  <FormGroup row>
                    <Label sm={2} for="periods">Actual {this.props.expense.chargingperiod.chargingperiod + 's'}</Label>
                    <Col sm={6}>
                      <InputGroup>
                        <Input
                          type="number"
                          innerRef={el => this.actualtime = el}
                          value={parseFloat(this.state.amountperiods)}
                          onChange={this.handlePeriodChange} />
                        <InputGroupAddon addonType="append">{this.props.expense.chargingperiod.chargingperiod + 's'}</InputGroupAddon>
                      </InputGroup>
                    </Col>
                  </FormGroup>
                }

                <FormGroup row>
                  <Label sm={2} for="amount">Actual Amount {this.state.vatrate !== 0 && '(net)'}</Label>
                  <Col sm={4}>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">£</InputGroupAddon>
                      <Input
                        disabled={this.props.expense.chargingperiod.id}
                        type="number"
                        innerRef={el => this.amountnet = el}
                        value={this.state.amountnet}
                        step={0.01}
                        onChange={this.handleNetChange} />
                    </InputGroup>
                  </Col>

                  {this.state.vatrate !== 0 &&
                    <React.Fragment>
                      <Label sm={2} for="amount">VAT</Label>
                      <Col sm={4}>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">£</InputGroupAddon>
                          <Input disabled type="number" innerRef={el => this.amountvat = el} value={parseFloat(this.state.amountvat).toFixed(2)} step={0.01} />
                        </InputGroup>
                      </Col>
                    </React.Fragment>
                  }
                </FormGroup>

                <FormGroup row>
                  <Label sm={2} for="amount">Note to justify change</Label>
                  <Col>
                    <Input type="textarea" rows='4' innerRef={el => this.notes = el} defaultValue={this.props.expense.notes} />
                  </Col>
                </FormGroup>

                <FormGroup row>
                  <Label sm={2}></Label>
                  <Col sm={4}>
                    <Button disabled={this.state.saving} color='primary' type="submit">Save Details</Button>
                  </Col>
                </FormGroup>
              </Form>
            </ModalBody>
          </Modal>

        </td>
      </tr>
    );
  }
}

export default JobDetail;


// WEBPACK FOOTER //
// ./src/JobDetail.js